import Loading, { LoadingBall } from '@ingka/loading';
import classNames from 'classnames';
import { ReactNode } from 'react';

import { PREFIX } from '../Skapa/constants/constants';
import Modal, { ModalBody, ModalHeader, Sheets } from '../Skapa/Modal/Modal';

import styles from './LoginModal/LoginModal.module.scss';

export const Wrapper = ({
  children,
  visible,
  loading,
  ariaLabel,
  title,
  noPadding,
  close,
  back,
}: {
  children?: ReactNode;
  loading?: boolean;
  visible: boolean;
  ariaLabel?: string;
  noPadding?: boolean;
  title?: string;
  close: () => void;
  back?: () => void;
}) => (
  <Modal onModalClosed={close} prefix={PREFIX} className="menuModal" visible={visible} handleCloseBtn={close}>
    <Sheets
      prefix={PREFIX}
      aria-label={ariaLabel ?? title ?? 'Menu'}
      className="menuSheetsModal"
      header={<ModalHeader backBtnClick={back} title={title} />}
      size="small"
      footer={null}
      preserveAlignment
      contentAttributes={{ tabIndex: -1 }}
    >
      <ModalBody prefix={PREFIX} className={classNames(styles.skapasModalBody, { [styles.noPadding]: noPadding })}>
        <div className={styles.menuModalBodyContainer}>
          {!!loading && (
            <Loading prefix={PREFIX} text="">
              <LoadingBall prefix={PREFIX} />
            </Loading>
          )}
          {children}
        </div>
      </ModalBody>
    </Sheets>
  </Modal>
);
